import HeroCarousel from "@/pages/home/components/HeroCarousel";
import GenreGrid from "@/pages/home/components/GenreGrid";
import LatestMovies from "@/pages/home/components/LatestMovies";
import NewsHighlights from "@/pages/home/components/NewsHighlights";
import ArchiveIntro from "@/pages/home/components/ArchiveIntro";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "80s电影 - 经典80年代电影推荐与影视资讯",
    "80s电影网站专注于80年代经典影视作品，涵盖电影介绍、影评和相关资讯，帮助用户回顾那个精彩的电影时代。",
    "80s电影,80年代电影,经典电影,怀旧电影,电影推荐,影视资讯,电影影评"
  );

  return (
    <>
      <HeroCarousel />
      <GenreGrid />
      <LatestMovies />
      <NewsHighlights />
      <ArchiveIntro />
    </>
  );
}